<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <btn :disabled="!logger.length" :uppercase="false" :class="['mx-1']" @click="logger = []" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.clearLog" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.clearLog }}</btn>
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <visibility-observer name="observer-1" @change="onVisibilityObserverChange" />
        <card>
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" v-html="$lang.visibilityLogger" />
          <card-text>
            <list v-if="logger.length" :clickable="false">
              <list-item v-for="(item, index) in logger" :title="JSON.stringify(item, null, 2)" :key="index" :class="[item.visibilityState === 'hidden' ? 'opacity-50' : null]">
                <list-item-icon v-html="index" />
                <list-item-content>
                  <list-item-content-title v-html="`name: ${item.name}`" />
                  <divider :class="['my-1']" />
                  <list-item-content-sub-title v-html="`timeStamp: ${item.timeStamp}`" />
                  <list-item-content-sub-title v-html="`visibilityState: ${item.visibilityState}`" />
                </list-item-content>
                <list-item-icon>
                  <icon :name="item.visibilityState === 'hidden' ? 'eye-off' : 'eye'" />
                </list-item-icon>
              </list-item>
            </list>
            <alert v-else v-model="alert" :dismissible="false">{{ $lang.visibilityLoggerInstructions }}</alert>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageVisibilityObserver',
  data () {
    return {
      logger: [],
      alert: true
    }
  },
  mixins: [
    methods
  ],
  methods: {
    onVisibilityObserverChange ($event) {
      this.log('change', 'visibility-observer', $event)
      this.logger.push($event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content/visibility-observer.vue